import * as service from './risk_management.service'
export default {
  data() {
    return {
      compliance_columns: ['Date', 'Title', 'AreaZone', 'DateAreaZoneHazard', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          FirstName: 'First Name',
          AreaZone: 'Area Zone',
          Title: 'Hazard',
          DateAreaZoneHazard: '',
          Actions: ''
        },
        columnsClasses: {
          "Date":"hydroware-date-column hidden-xs hidden-sm",
          "Title":"hidden-xs hidden-sm",
          "AreaZone":"hidden-xs hidden-sm",
          "Actions":"hydroware-2-button-column",
          "DateAreaZoneHazard":"hidden-md hidden-lg hidden-xl hydroware-label-in-column"
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      HazardBO: {

        "PoolId": '',
        "AreaZone": "",
        "Title": "",
        "Description": "",
        "Date": "",


      },

      rules: {

        AreaZone: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        Title: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        Date: [

          {
            type: 'date',
            required: true,
            message: 'This field is required'
          },

        ],

      },
      Hazards: [],

      modalTitle: '',
      locationId: '',
      poolId: '',
      poolName: '',
      locationName: '',
      isediting: false,
      isaddding: false,
      isAddingOrEditing: "" //FG - FOOF - After Cert - First Release Security (7)

    }
  },
  mounted() {
    let context = this

    this.$router.app.$on('emittedlocation_obj', (data) => {

      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      // context.GetAllMembers(context.locationId)

    })
    this.$router.app.$on('emittedpool_obj', (data) => {

      context.poolId = data.PoolId ? data.PoolId : ''
      context.poolName = data.PoolName ? '(Pool : ' + data.PoolName + ')' : ''
      if (context.poolId) {
        context.GetAllHazards(context.poolId)
      }


      // alert(JSON.stringify(data))


    })



  },

  methods: {

    addCompliancevit() {

      if (!this.poolId) {
        this.$notify({
          title: 'Error',
          message: 'No pools associated with this location',
          type: 'error'
        })
      } else {
        this.isaddding = true
        this.isAddingOrEditing="A"

        this.HazardBO = {

          "PoolId": '',
          "AreaZone": "",
          "Title": "",
          "Description": "",
          "Date": "",


        }
      }



    },
    showCompliancevit() {

      this.isaddding = false
      this.isediting = false
      isAddingOrEditing = ""
    },

    GetAllHazards(poolId) {
      let context = this
      loader.startLoader()
      service.GetAllHazards(poolId).then(function (response) {

      //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
      if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
        context.Hazards = [] 
        return;
      }
      //FG - FOOF - After Cert - First Release Security (7) - above\
      
        if (response && response != null) {
          context.Hazards = response
          tooltip.startTooltip(50)
        } else {

          context.Hazards = []
        }

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },





    del: function (data) {
      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete ' + data.row.Title +'?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteHazard(ID).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

          context.GetAllHazards(context.poolId)
          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.Id
      let context = this
      context.EditableColID = ID

      context.HazardBO = data.row
      context.HazardBO["Date"] = new Date(data.row.Date)
      context.HazardBO["Id"] = data.row.Id
      context.isediting = true
      context.isAddingOrEditing = "E"

    },


    AddHazard(formName) {
      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          context.HazardBO['PoolId'] = context.poolId
          context.HazardBO['Date'] = context.$options.filters.fdate(context.HazardBO['Date'])
          service.AddHazard(context.HazardBO).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
              return;

            loader.stopLoader()
            context.$notify({
              title: 'Success',
              message: 'Hazard  Created',
              type: 'success'
            })
            context.GetAllHazards(context.poolId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""


          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'RISK MGT - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    UpdateHazard(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          //context.addAccount['LocationId'] = context.locationId

          context.HazardBO['Date'] = context.$options.filters.fdate(context.HazardBO['Date'])
          // context.addCompliance['Id'] =
          service.UpdateHazard(context.HazardBO).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
              return;

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Hazard  Updated',
              type: 'success'
            })
            context.GetAllHazards(context.poolId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""


          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'RISK MANAGEENT - 2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }


  },

}



// WEBPACK FOOTER //
// ./src/pages/RiskManagement/riskmanagement.controller.js